import {Component, Input} from '@angular/core';
import {RuleConfig} from "../../../../model/channels.model";

@Component({
  selector: 'admin-channels-view-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent {

  @Input() rules?: RuleConfig[];

}
